import {convertEnToPe} from "../../utiles/Ops";
import {IconSetting} from "../Icons/Setting";
import {useNavigate} from "react-router-dom";

export const DiscountMenu = ({user}) => {
    const navigate = useNavigate();
    return (
        <div className="flex justify-between items-start w-full bg-[#9e8cec] rounded p-3 mb-2 cursor-pointer"
             onClick={() => navigate("/discounts")}>
            <div className="flex gap-x-2">
                <IconSetting color="white"/>
                <div> تخفیف ها </div>
            </div>
            <div className="flex gap-x-2">
                <span>{convertEnToPe(user?.discounts?.length)}</span>
            </div>
        </div>
    );
};
